import { useState } from "react";

export const useGestionRoles = () => {

    const [usuarios,] = useState(data);

    const [cantidadpaginas, setCantidadPaginas] = useState<number>(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    return {
        usuarios,
        cantidadpaginas,
        cambiarCantidadPaginas
    }

}


let data = [
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Activo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Activo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Inactivo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Activo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Inactivo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Activo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Inactivo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Activo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Inactivo",
        fecha: "13/01/2022"
    },
    {
        tipo_doc: 'CC',
        numero_documento: '1017196609',
        nombre_completo: 'Roberto Gomez Bolaños',
        rol: "Administrador",
        estado: "Inactivo",
        fecha: "13/01/2022"
    },
]